/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { creditApplicationDocumentFragment } from '../../../../apollo/fragments/creditApplicationDocumentFragment.gql';
import { applicationActionItemFragment } from '../../../../apollo/fragments/applicationActionItemFragment.gql';
import { BankAccount } from '../../../../apollo/fragments/BankAccount.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCreditApplicationDetails_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo = { readonly __typename: 'CreditApplicationBusinessInfo', readonly legalBusinessName: string | null };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson_accountSetupInvitation_AccountSetupInvitation = { readonly __typename: 'AccountSetupInvitation', readonly token: string | null };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly accountSetupInvitation: GetCreditApplicationDetails_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson_accountSetupInvitation_AccountSetupInvitation | null };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_personaInquiries_PersonaInquiry_person_SignedCreditApplicationPerson = { readonly __typename: 'SignedCreditApplicationPerson', readonly firstName: string, readonly lastName: string };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_personaInquiries_PersonaInquiry = { readonly __typename: 'PersonaInquiry', readonly status: _Types.PersonaInquiryStatus, readonly inquiryId: string, readonly person: GetCreditApplicationDetails_creditApplication_CreditApplication_personaInquiries_PersonaInquiry_person_SignedCreditApplicationPerson };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_supportingDocuments_CreditApplicationDocument = { readonly __typename: 'CreditApplicationDocument', readonly documentType: _Types.CreditDocument, readonly documentUuid: string, readonly isReRequested: boolean, readonly statusMessage: string | null, readonly fileName: string | null, readonly status: string | null, readonly signedUrl: string | null, readonly unsignedPath: string | null };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_requiredDocs_CreditApplicationDocument = { readonly __typename: 'CreditApplicationDocument', readonly documentType: _Types.CreditDocument, readonly documentUuid: string, readonly isReRequested: boolean, readonly statusMessage: string | null, readonly fileName: string | null, readonly status: string | null, readonly signedUrl: string | null, readonly unsignedPath: string | null };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_applicationActionItems_ApplicationActionItem_metadata_ApplicationActionItemMetadata = { readonly __typename: 'ApplicationActionItemMetadata', readonly documentsRemaining: ReadonlyArray<string | null> | null };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_applicationActionItems_ApplicationActionItem = { readonly __typename: 'ApplicationActionItem', readonly id: string, readonly action: string, readonly completedAt: any | null, readonly insertedAt: any, readonly sourceId: string | null, readonly sourceType: string | null, readonly metadata: GetCreditApplicationDetails_creditApplication_CreditApplication_applicationActionItems_ApplicationActionItem_metadata_ApplicationActionItemMetadata | null };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_selectedBankInfo_BankInfo = { readonly __typename: 'BankInfo', readonly id: string | null, readonly accountHolderName: string | null, readonly accountNumberLength: number | null, readonly accountNumberLastFour: string | null, readonly bankName: string | null, readonly routingNumber: string | null, readonly source: _Types.CreditApplicationBankSource | null, readonly externalConnectionGuid: string | null, readonly logoUrl: string | null };

export type GetCreditApplicationDetails_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo = { readonly __typename: 'CreditApplicationFinanceInfo', readonly desiredCredit: any | null, readonly selectedBankInfo: GetCreditApplicationDetails_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_selectedBankInfo_BankInfo | null };

export type GetCreditApplicationDetails_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly bdcOrgId: string | null, readonly dsaVersion: string | null, readonly startedAt: any | null, readonly shouldBeExpiredAt: any | null, readonly status: _Types.CreditApplicationStatus | null, readonly statusCategory: _Types.StatusCategory | null, readonly fundableLimit: number | null, readonly businessInfo: GetCreditApplicationDetails_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo | null, readonly authorizedSigner: GetCreditApplicationDetails_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null, readonly beneficialOwners: ReadonlyArray<GetCreditApplicationDetails_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson | null> | null, readonly outsourcedAccountant: GetCreditApplicationDetails_creditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson | null, readonly personaInquiries: ReadonlyArray<GetCreditApplicationDetails_creditApplication_CreditApplication_personaInquiries_PersonaInquiry>, readonly supportingDocuments: ReadonlyArray<GetCreditApplicationDetails_creditApplication_CreditApplication_supportingDocuments_CreditApplicationDocument> | null, readonly requiredDocs: ReadonlyArray<GetCreditApplicationDetails_creditApplication_CreditApplication_requiredDocs_CreditApplicationDocument> | null, readonly applicationActionItems: ReadonlyArray<GetCreditApplicationDetails_creditApplication_CreditApplication_applicationActionItems_ApplicationActionItem>, readonly financeInfo: GetCreditApplicationDetails_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo | null };

export type GetCreditApplicationDetails_Query = { readonly __typename: 'Query', readonly creditApplication: GetCreditApplicationDetails_creditApplication_CreditApplication | null };


export type GetCreditApplicationDetailsVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetCreditApplicationDetails = GetCreditApplicationDetails_Query;


export const GetCreditApplicationDetailsDocument = gql`
    query GetCreditApplicationDetails($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    bdcOrgId
    dsaVersion
    businessInfo {
      legalBusinessName
    }
    authorizedSigner {
      id
      email
      firstName
      lastName
      accountSetupInvitation {
        token
      }
    }
    beneficialOwners {
      id
      email
      firstName
      lastName
    }
    outsourcedAccountant {
      id
      email
      firstName
      lastName
    }
    personaInquiries {
      status
      inquiryId
      person {
        firstName
        lastName
      }
    }
    startedAt
    shouldBeExpiredAt
    status
    statusCategory
    fundableLimit
    supportingDocuments {
      ...creditApplicationDocumentFragment
    }
    requiredDocs {
      ...creditApplicationDocumentFragment
    }
    applicationActionItems {
      ...applicationActionItemFragment
    }
    financeInfo {
      desiredCredit
      selectedBankInfo {
        ...BankAccount
      }
    }
  }
}
    ${creditApplicationDocumentFragment}
${applicationActionItemFragment}
${BankAccount}`;

/**
 * __useGetCreditApplicationDetails__
 *
 * To run a query within a React component, call `useGetCreditApplicationDetails` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditApplicationDetails` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditApplicationDetails({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetCreditApplicationDetails(baseOptions: Apollo.QueryHookOptions<GetCreditApplicationDetails, GetCreditApplicationDetailsVariables> & ({ variables: GetCreditApplicationDetailsVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditApplicationDetails, GetCreditApplicationDetailsVariables>(GetCreditApplicationDetailsDocument, options);
      }
export function useGetCreditApplicationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditApplicationDetails, GetCreditApplicationDetailsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditApplicationDetails, GetCreditApplicationDetailsVariables>(GetCreditApplicationDetailsDocument, options);
        }
export function useGetCreditApplicationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditApplicationDetails, GetCreditApplicationDetailsVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditApplicationDetails, GetCreditApplicationDetailsVariables>(GetCreditApplicationDetailsDocument, options);
        }
export type GetCreditApplicationDetailsHookResult = ReturnType<typeof useGetCreditApplicationDetails>;
export type GetCreditApplicationDetailsLazyQueryHookResult = ReturnType<typeof useGetCreditApplicationDetailsLazyQuery>;
export type GetCreditApplicationDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCreditApplicationDetailsSuspenseQuery>;
export type GetCreditApplicationDetailsQueryResult = Apollo.QueryResult<GetCreditApplicationDetails, GetCreditApplicationDetailsVariables>;